<template>
  <div class="permissions">
    <el-menu
      :default-active="activeSelect"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item index="1">授权权限管理</el-menu-item>
      <el-menu-item index="2" v-if="isRoles">专家管理</el-menu-item>
      <el-menu-item index="3" v-if="isRoles">机构专家管理</el-menu-item>
    </el-menu>
    <div v-if="activeSelect === '1'" class="permissions_box" v-loading="loading">
      <div class="permissions_box_header">
        <div></div>
        <el-button type="primary" style="float:right" @click="dialogFormVisibleAut = true">新增</el-button>
      </div>
      <div class="permissions_box_table">
        <template>
          <el-table :data="autList" border style="width: 100%">
            <el-table-column label="专家" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.ManagedExpert.Name}}</template>
            </el-table-column>
            <el-table-column label="KID" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.ManagedExpert.KId}}</template>
            </el-table-column>
            <el-table-column label="机构" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.ManagedExpert.Organization || '暂无机构信息'}}</template>
            </el-table-column>
            <el-table-column label="授权用户名" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.PermitUserName}}</template>
            </el-table-column>
            <el-table-column label="操作" width="300">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  @click="dialogFormVisibleAutView = true; aut = scope.row"
                  size="mini"
                >查看权限</el-button>
                <el-button
                  type="warning"
                  @click="dialogFormVisibleAutEdit = true; aut = scope.row; "
                  size="mini"
                >修改权限</el-button>
                <el-button type="danger" @click="delAut(scope.row)" size="mini">取消授权</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
      <pagination
        :total="pageData1.total"
        :page.sync="pageData1.PageIndex"
        :limit.sync="pageData1.PageSize"
        :pageSizes="pageData1.PageSizes"
        :layout="layout"
        @pagination="getPage1"
      />
    </div>
    <div v-if="activeSelect === '2'" class="permissions_box" v-loading="loading">
      <div class="permissions_box_header">
        <div class="permissions_box_header_searchInfo">
          <span>机构选择：</span>
          <el-select v-model="org" placeholder="请选择">
            <el-option
              disabled
              v-for="item in options"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
          <span>专家信息：</span>
          <el-input v-model="expName1" placeholder="请输入专家名" clearable></el-input>
        </div>
        <el-button type="primary" style="float:right" @click="searchExp">搜索</el-button>
      </div>
      <div class="permissions_box_table">
        <template>
          <el-table :data="expList" border style="width: 100%">
            <el-table-column label="专家" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.ManagedExpert.Name}}</template>
            </el-table-column>
            <el-table-column label="KID" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.ManagedExpert.KId}}</template>
            </el-table-column>
            <el-table-column label="机构">
              <template slot-scope="scope">{{scope.row.ManagedExpert.Organization || '暂无机构信息'}}</template>
            </el-table-column>
            <el-table-column label="已授权">
              <template slot-scope="scope">
                <span
                  v-for="item in scope.row.Permissions"
                  :key="item"
                  style="margin-right:10px"
                >{{item.Name}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="300">
              <template slot-scope="scope">
                <!-- <el-button type="danger" @click="claim(scope.row)" size="mini">成果认领</el-button> -->
                <el-button
                  type="warning"
                  @click="management(scope.row)"
                  size="mini"
                >成果管理</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
      <pagination
        :total="pageData2.total"
        :page.sync="pageData2.PageIndex"
        :limit.sync="pageData2.PageSize"
        :pageSizes="pageData2.PageSizes"
        :layout="layout"
        @pagination="getPage2"
      />
    </div>
    <div v-if="activeSelect === '3'" class="permissions_box" v-loading="loading">
      <div class="permissions_box_header">
        <div class="permissions_box_header_searchInfo">
          <span>专家名：</span>
          <el-input v-model="expName2" placeholder="请输入专家名" clearable></el-input>
        </div>
        <el-button type="primary" @click="searcOrg">搜索</el-button>
      </div>
      <div class="permissions_box_table">
        <template>
          <el-table :data="orgList" border style="width: 100%">
            <el-table-column label="姓名" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.ExpertName}}</template>
            </el-table-column>
            <el-table-column label="机构" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.ExpertOrganization || '暂无机构信息'}}</template>
            </el-table-column>
            <el-table-column label="部门" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.ExpertDepartment || '暂无部门信息'}}</template>
            </el-table-column>
            <el-table-column label="学科">
              <template slot-scope="scope">{{scope.row.ExpertDepartment || '暂无学科信息'}}</template>
            </el-table-column>
            <el-table-column label="认领情况">
              <template slot-scope="scope">{{scope.row.IsClaim ? '已认领':'未认领'}}</template>
            </el-table-column>

            <el-table-column label="操作" width="300">
              <template slot-scope="scope">
                <el-button type="danger" @click="searchName(scope.row)" size="mini">认领</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
      <pagination
        :total="pageData3.total"
        :page.sync="pageData3.PageIndex"
        :limit.sync="pageData3.PageSize"
        :pageSizes="pageData3.PageSizes"
        :layout="layout"
        @pagination="getPage3"
      />
    </div>
    <!-- 新增授权管理 -->
    <el-dialog title="新增授权管理" :visible.sync="dialogFormVisibleAut">
      <div class="dialog_aut">
        <el-input placeholder="请输入用户账号" v-model="userName" clearable></el-input>
        <el-button type="primary" @click="searchUserName" :loading="loading">搜索</el-button>
      </div>
      <div class="dialog_autView" v-if="Object.keys(searchExpList).length">
        <div class="autInfo">
          <lable>姓名：</lable>
          <span>{{searchUser.Name}}</span>
        </div>
        <div class="autInfo">
          <lable>授权项：</lable>
          <el-checkbox-group v-model="checkList">
            <el-checkbox v-for="item in perList" :key="item" :label="item"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="autInfo">
          <lable>专家：</lable>
          <el-checkbox-group v-model="checkExpList">
            <el-checkbox
              v-for="(item,index) in searchExpList"
              :key="index"
              :label="index"
            >{{item.ManagedExpert.Name}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleAut = false">取 消</el-button>
        <el-button
          type="primary"
          @click="addSave"
          :loading="loading"
          v-if="Object.keys(searchExpList).length"
        >保 存</el-button>
      </div>
    </el-dialog>
    <!-- 查看权限 -->
    <el-dialog title="查看权限" :visible.sync="dialogFormVisibleAutView">
      <div class="dialog_autView">
        <div class="autInfo">
          <lable>姓名：</lable>
          <span>{{aut.PermittedUserName}}</span>
        </div>
        <div class="autInfo">
          <lable>授权项：</lable>
          <div class="autInfoRow">
            <span
              style="margin-right:20px"
              v-for="item in aut.Permissions"
              :key="item"
            >{{item.Name}}</span>
          </div>
        </div>
        <div class="autInfo">
          <lable>专家：</lable>
          <span v-if="aut.ManagedExpert">{{aut.ManagedExpert.Name}}</span>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogFormVisibleAutView = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改权限 -->
    <el-dialog title="修改权限" :visible.sync="dialogFormVisibleAutEdit">
      <div class="dialog_autView">
        <div class="autInfo">
          <lable>姓名：</lable>

          <span>{{aut.PermittedUserName}}</span>
        </div>
        <div class="autInfo">
          <lable>授权项：</lable>
          <el-checkbox-group v-model="checkList">
            <el-checkbox v-for="item in perList" :key="item" :label="item"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="autInfo">
          <lable>专家：</lable>
          <span v-if="aut.ManagedExpert">{{aut.ManagedExpert.Name}}</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editAut">保 存</el-button>
        <el-button type="danger" @click="dialogFormVisibleAutEdit = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAuthorizationExp,
  getOrg,
  getUser,
  editExpAut,
  confirmPer,
  addExp,
  delExpAut
} from '@/api/center'
import Pagination from '@/components/Pagination'
export default {
  name: 'focus',
  components: {
    Pagination
  },
  props: {
    isHttp: {
      type: String
    },
    isRoles: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      activeSelect: '1', // 管理类型
      /* 3个管理列表 */
      autList: [],
      expList: [],
      orgList: [],
      searchExpList: [], // 新增授权管理
      checkExpList: [], // 新增授权专家数组
      perList: [
        '简历管理',
        '履历管理',
        '历史成果管理',
        '新增成果管理',
        '成果内容管理',
        '关注量统计查看'
      ], // 授权项
      aut: {}, // 单个专家
      expName1: '', // 专家姓名输入
      expName2: '', // 专家姓名输入
      userName: '', // 用户账号
      options: [], // 机构列表
      org: '', // 机构
      checkList: [], // 授权项
      /* 分页 */
      pageData1: {
        total: '',
        PageIndex: 1,
        PageSize: 10,
        pageSizes: [10]
      },
      pageData2: {
        total: '',
        PageIndex: 1,
        PageSize: 10,
        pageSizes: [10]
      },
      pageData3: {
        total: '',
        PageIndex: 1,
        PageSize: 10,
        pageSizes: [10]
      },
      layout: 'sizes, prev, pager, next, jumper',
      /* 弹窗 */
      dialogFormVisibleAut: false,
      dialogFormVisibleAutView: false,
      dialogFormVisibleAutEdit: false,
      loading: false,
      Http: true
    }
  },
  methods: {
    // 菜单选择
    handleSelect (index) {
      this.activeSelect = index
    },
    // 获取选项管理专家
    getAuthorizationExp () {
      this.loading = true
      let data = {
        PageIndex: this.pageData1.PageIndex,
        PageSize: this.pageData1.PageSize
      }
      getAuthorizationExp(data).then(res => {
        this.loading = false
        this.autList = res.data.Data
        this.pageData1.total = res.data.Pages.RecordSum
      })
    },
    // 获取专家管理
    getExp (name) {
      let data
      if (name) {
        this.pageData2.PageIndex = 1
        data = {
          PageIndex: this.pageData2.PageIndex,
          PageSize: this.pageData2.PageSize,
          ManagedExpertName: name
        }
      } else {
        data = {
          PageIndex: this.pageData2.PageIndex,
          PageSize: this.pageData2.PageSize
        }
      }
      this.loading = true
      getAuthorizationExp(data).then(res => {
        this.loading = false
        this.expList = res.data.Data
        this.pageData2.total = res.data.Pages.RecordSum
      })
    },
    // 获取机构专家管理
    getOrg (name) {
      let data
      this.loading = true
      if (name) {
        this.pageData2.PageIndex = 1
        data = {
          PageIndex: this.pageData3.PageIndex,
          PageSize: this.pageData3.PageSize,
          ExpertName: name
        }
      } else {
        data = {
          PageIndex: this.pageData3.PageIndex,
          PageSize: this.pageData3.PageSize
        }
      }

      getOrg(data).then(res => {
        this.loading = false
        this.orgList = res.data.Data
        this.pageData3.total = res.data.Pages.RecordSum
      })
    },
    /* 跳转页面 */
    getPage1 (page) {
      this.pageData1.PageIndex = page.page
      this.getAuthorizationExp()
    },
    getPage2 (page) {
      this.pageData2.PageIndex = page.page
      this.getExp()
    },
    getPage3 (page) {
      this.pageData3.PageIndex = page.page
      this.getOrg()
    },
    // 搜索账号信息
    searchUserName () {
      this.loading = true
      if (!this.userName) {
        this.$message({
          showClose: true,
          message: '请输入用户账号',
          offset: 200
        })
        return
      }
      let data = {
        no: this.userName
      }
      getUser(data).then(res => {
        if (!res.status) {
          this.loading = false
          this.$message({
            showClose: true,
            message: res.msg,
            offset: 200
          })
          return
        }
        this.searchUser = res.data
        this.searchExpS()
      })
    },
    // 搜索账号信息
    searchExpS () {
      let data = {
        PageIndex: 1,
        PageSize: 245
      }
      getAuthorizationExp(data).then(res => {
        this.searchExpList = res.data.Data
        this.loading = false
      })
    },
    // 添加权限
    addSave () {
      this.loading = true
      let ManagedExpert = []
      let Permissions = []
      this.checkList.forEach(item => {
        let temp = {
          Category: null,
          Comment: null,
          DisplayNo: 0,
          Id: null,
          IsValid: false,
          Name: item,
          ParentId: null
        }
        switch (item) {
          case '简历管理':
            temp.Id = 'UserFunc01'
            break
          case '履历管理':
            temp.Id = 'UserFunc02'
            break
          case '历史成果管理':
            temp.Id = 'UserFunc03'
            break
          case '新增成果管理':
            temp.Id = 'UserFunc04'
            break
          case '成果内容管理':
            temp.Id = 'UserFunc05'
            break
          case '关注量统计查看':
            temp.Id = 'UserFunc06'
            break
          default:
            break
        }
        Permissions.push(temp)
      })
      this.checkExpList.forEach(index => {
        ManagedExpert.push(this.searchExpList[index].ManagedExpert)
      })
      let data = {
        AllowDeliver: false,
        PermitUserId: this.user.Id,
        ManagedExpert: ManagedExpert,
        Permissions: Permissions,
        PermitUserName: this.user.Name,
        PermittedUserId: this.user.Id,
        PermittedUserName: this.user.Name,
        Rank: 1
      }
      addExp(data).then(res => {
        this.loading = false
        this.$message({
          showClose: true,
          message: res.msg,
          offset: 200
        })
      })
    },
    // 修改权限
    editAut () {
      let Permissions = []
      this.checkList.forEach(element => {
        let temp = {
          Category: null,
          Comment: null,
          DisplayNo: 0,
          Id: null,
          IsValid: false,
          Name: element,
          ParentId: null
        }
        switch (element) {
          case '简历管理':
            temp.Id = 'UserFunc01'
            break
          case '履历管理':
            temp.Id = 'UserFunc02'
            break
          case '历史成果管理':
            temp.Id = 'UserFunc03'
            break
          case '新增成果管理':
            temp.Id = 'UserFunc04'
            break
          case '成果内容管理':
            temp.Id = 'UserFunc05'
            break
          case '关注量统计查看':
            temp.Id = 'UserFunc06'
            break
          default:
            break
        }
        Permissions.push(temp)
      })
      let data = this.aut
      data.Permissions = Permissions
      editExpAut(data).then(res => {
        this.$message({
          showClose: true,
          message: res.msg,
          offset: 200
        })
        this.dialogFormVisibleAutEdit = false
        this.getAuthorizationExp()
      })
    },
    // 删除权限
    delAut (data) {
      let temp = []
      this.loading = true
      temp.push(data.ManagedExpert)
      data.ManagedExpert = temp
      delExpAut(data).then(res => {
        this.loading = false
        this.$message({
          showClose: true,
          message: res.msg,
          offset: 200
        })
        this.getAuthorizationExp()
      })
    },
    // 专家管理搜索
    searchExp () {
      this.getExp(this.expName1)
    },
    // 跳转到成果管理
    management (data) {
      let routeData = this.$router.resolve({
        name: 'manage',
        query: { kid: data.ManagedExpert.KId }
      })
      window.open(routeData.href, '_blank')
    },

    // 机构专家管理搜索
    searcOrg () {
      this.getOrg(this.expName2)
    },
    // 认领
    searchName (data) {
      let k = data.ExpertName + ' ' + data.ExpertOrganization
      let routeData = this.$router.resolve({
        name: 'Loading',
        query: { data: k }
      })
      window.open(routeData.href, '_blank')
    }
  },
  watch: {
    /*  */
    isHttp: {
      handler (val) {
        if (this.isHttp === '1' || this.isHttp === '2') {
          if (this.Http) {
            this.getAuthorizationExp()
            this.getExp()
            this.getOrg()
          }
          this.Http = false
          this.activeSelect = this.isHttp === '1' ? '1' : '2'
        }
      }
    },
    dialogFormVisibleAutEdit: {
      deep: true,
      handler (val) {
        this.checkList = []
        if (val) {
          this.aut.Permissions.forEach(item => [
            this.checkList.push(item.Name)
          ])
        }
      }
    },
    dialogFormVisibleAut: {
      deep: true,
      handler (val) {
        this.checkList = []
        this.userName = ''
        this.checkExpList = []
        this.searchExpList = []
      }
    }
  },
  mounted () {}
}
</script>

<style lang="scss">
.permissions {
  .permissions_box {
    padding: 0 40px;
    .permissions_box_header {
      width: 100%;
      padding: 20px 0;
      display: flex;
      flex-direction: row;

      .permissions_box_header_searchInfo {
        width: 60%;
        .el-input {
          width: 30%;
        }
        .el-select {
          width: 30%;
          margin-right: 20px;
          .el-input--suffix {
            width: 100%;
          }
        }
      }
    }
  }
  .el-dialog {
    .dialog_aut {
      .el-input {
        width: 80%;
        margin-right: 20px;
      }
    }
    .dialog_autView {
      font-size: 1.1rem;
      padding: 0 10%;
      .autInfo {
        margin: 20px 0;
        display: flex;
        flex-direction: row;
        .autInfoRow {
          width: 80%;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
        }
        lable {
          display: inline-block;
          text-align: right;
          width: 15%;
        }
        .el-checkbox-group {
          width: 80%;
          .el-checkbox__label {
            font-size: 16px;
          }
          .el-checkbox {
            width: 20%;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/center/menu/permissions.vue